import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { OrganicCreditScore, FlockDNA } from '@/types/cbs';

interface CBSScoreStore {
  currentScore: OrganicCreditScore | null;
  scoreHistory: OrganicCreditScore[];
  flockDNA: FlockDNA | null;
  
  setCurrentScore: (score: OrganicCreditScore) => void;
  setFlockDNA: (dna: FlockDNA) => void;
  addToHistory: (score: OrganicCreditScore) => void;
  clearScores: () => void;
}

export const useCBSScoreStore = create<CBSScoreStore>()(
  persist(
    (set) => ({
      currentScore: null,
      scoreHistory: [],
      flockDNA: null,
      
      setCurrentScore: (score) => set({ currentScore: score }),
      setFlockDNA: (dna) => set({ flockDNA: dna }),
      addToHistory: (score) => set((state) => ({
        scoreHistory: [score, ...state.scoreHistory].slice(0, 24), // Keep 24 months
      })),
      clearScores: () => set({ currentScore: null, scoreHistory: [], flockDNA: null }),
    }),
    { name: 'cbs-score-storage' }
  )
);
